const bank = require('./bank');
const creditCard = require('./credit-card');
const billingAddress = require('./billing-address');

module.exports = {
    type: 'object',
    additionalProperties: false,
    properties: {
        type: {
            type: 'string'
        },
        bePaymentTypeId: {
            type: ['number', 'null']
        },
        paymentTypeId: {
            type: ['number', 'null']
        },
        currencyCode: {
            type: 'string'
        },
        action: {
            type: 'string'
        },
        installments: {
            type: 'number'
        },
        paymentNumber: {
            type: ['string', 'null']
        },
        paymentName: {
            type: 'string'
        },
        ofsId: {
            type: ['string', 'null']
        },
        creditCard: {
            oneOf: [
                creditCard,
                {
                    type: 'null'
                }
            ]
        },
        bank: {
            oneOf: [
                bank,
                {
                    type: 'null'
                }
            ]
        },
        billingAddress: billingAddress,
        storedCredentialsAgreementDate: {
            type: ['string', 'null']
        },
        storedCredentialsNetworkTransactionId: {
            type: ['string', 'null']
        },
        storedCredentialsNetworkDateStr: {
            type: ['string', 'null']
        }
    }
};
